import { render, staticRenderFns } from "./PageComprobantes.vue?vue&type=template&id=1629da14"
import script from "./PageComprobantes.vue?vue&type=script&lang=js"
export * from "./PageComprobantes.vue?vue&type=script&lang=js"
import style0 from "./PageComprobantes.vue?vue&type=style&index=0&id=1629da14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports